





















import { defineComponent } from '@vue/composition-api';
import IosIcon from '@tt4b/ttam-assets/src/svgs/icon-ios.svg';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ios14-info-policy-info';
export default defineComponent({
  name,
  components: {
    ALink,
    IosIcon,
  },
  setup() {
    return {
      name,
    };
  },
});
